<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>

export default {

  name: 'App',
  data() {
    return {
      openedTabs: ['PolicyQuery', 'collect']
    }
  },
  computed: {
  },
  mounted(){
  },
  methods: {
  }
}
</script>
<style lang="scss">
</style>
